module.exports = __webpack_public_path__ + "static/img/arrow-down.11fba2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-down.svg
// module id = zpNP
// module chunks = 1